import * as Yup from 'yup';

export const createAdminGroupValidate = Yup.object().shape({
  name: Yup.string()
    .required('Field is required'),
  identifier: Yup.string()
    .required('This field in required!'),
});